var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.705384 0.294459C1.09466 -0.0948134 1.72569 -0.0951574 2.11538 0.293691L5.29366 3.46505C5.68401 3.85454 6.31599 3.85454 6.70634 3.46505L9.88462 0.29369C10.2743 -0.0951576 10.9053 -0.0948134 11.2946 0.294459C11.6842 0.684032 11.6842 1.31565 11.2946 1.70523L6.70711 6.29274C6.31658 6.68326 5.68342 6.68326 5.29289 6.29274L0.705384 1.70523C0.315811 1.31565 0.315811 0.684032 0.705384 0.294459Z",
    fill: "#5FC1CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomArrow);
export default __webpack_public_path__ + "static/media/bottomArrow.075948d73973df7022691ec5657d8fc4.svg";
export { ForwardRef as ReactComponent };